/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statistics_Newitemadded2Inputs */

const he_statistics_newitemadded2 = /** @type {(inputs: Statistics_Newitemadded2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מוצרים חדשים שנוספו`)
};

const en_statistics_newitemadded2 = /** @type {(inputs: Statistics_Newitemadded2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New items added`)
};

/**
* | output |
* | --- |
* | "New items added" |
*
* @param {Statistics_Newitemadded2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const statistics_newitemadded2 = /** @type {((inputs?: Statistics_Newitemadded2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statistics_Newitemadded2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_statistics_newitemadded2(inputs)
	return en_statistics_newitemadded2(inputs)
});
export { statistics_newitemadded2 as "statistics_newItemAdded" }